import actions from './actions';
import { createReducer } from '../../../../helpers/reducer';

const initState = {
  markets: null,
  loading: false,
  filteredTotal: 0,
  filters: null,
  total: 0,
};

function onLoadRequest(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { records, total, filteredTotal, filters } = payload;

  return {
    ...state,
    markets: records,
    filters,
    total,
    filteredTotal,
    loading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD_REQUEST]: onLoadRequest,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
